module.exports = __webpack_public_path__ + "img/centennial-tic-resilience-quote4.bc2f4d7c.svg";